<template>
    <div class="product">
        <div class="product-detail" v-if="showColorModal == false && lang=='fr'">
            <section>
                <label>Modèle :</label>
                <div class="inb">
                    <input type="radio" :checked="glove.gender == 'M'" v-on:change="updateField('gender', $event.target.value)" value="M" @change="this.onGenderChanged" /> Homme<br />
                    <input type="radio" :checked="glove.gender == 'W'" v-on:change="updateField('gender', $event.target.value)" value="W" @change="this.onGenderChanged" /> Femme<br />
                </div>
            </section>

            <section>
                <label>Taille :</label>
                <select :value="glove.size" v-on:change="updateField('size', $event.target.value)" v-if="glove.gender != 'W'">
                    <option>8</option>
                    <option>8,5</option>
                    <option>9</option>
                    <option>9,5</option>
                </select>
              <select :value="glove.size" v-on:change="updateField('size', $event.target.value)" v-if="glove.gender == 'W'">
                <option>7</option>
                <option>7,5</option>
                <option>8</option>
              </select>
                <p>
                    Vous ne connaissez pas votre taille ?<br/>
                    <a href="../../static/pdf/web/la_taille_de_vos_gants.pdf" target="_blank">Cliquez ici pour télécharger notre outil de mesure</a>
                </p>
            </section>

            <section>
                <label>Quantité :</label>
                <input type="number" :value="glove.quantity" v-on:change="updateField('quantity', $event.target.value)" min="1" max="10"/> paire(s)
            </section>

            <section>
                <label>Couleur :</label>
                <button v-if="glove.color == null" class="focus" @click="this.openModal">Cliquez ici pour choisir votre couleur</button>
                <div class="selected-color" v-if="glove.color != null">
                    <div>
                        <div v-if="glove.color != null" :class="'color ' + glove.color"></div>
                        <div class="color-detail">
                            <h4>{{ glove.colorLabelFR }}</h4>
                            <button v-if="glove.color != null" href="" class="focus" @click="this.openModal">Modifier votre couleur</button>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <button <button :class="'focus' + (! canOrder ? ' disabled' : '')" @click="addToCart">Cliquez ici pour ajouter ces gants au panier</button>
            </section>

            <section>
                {{ cartDescription }}
                <button :disabled="!hasItems" @click="this.openCart" class="order-action">Visualisez votre panier <br />et finalisez votre commande</button>
            </section>
        </div>

        <div class="product-detail" v-if="showColorModal == false && lang=='en'">

            <section>
                <label>Style :</label>
                <div class="inb">
                    <input type="radio" :checked="glove.gender == 'M'" v-on:change="updateField('gender', $event.target.value)" value="M" @change="this.onGenderChanged" /> Men<br />
                    <input type="radio" :checked="glove.gender == 'W'" v-on:change="updateField('gender', $event.target.value)" value="W" @change="this.onGenderChanged" /> Women<br />
                </div>
            </section>

            <section>
                <label>Size :</label>
                <select :value="glove.size" v-on:change="updateField('size', $event.target.value)">
                    <option>8</option>
                    <option>8,5</option>
                    <option>9</option>
                    <option>9,5</option>
                </select>
                <p>
                    Don't know your size ?<br/>
                    <a href="../../static/pdf/web/la_taille_de_vos_gants.pdf" target="_blank">Click here to download our measuring tool.</a>
                </p>
            </section>

            <section>
                <label>Quantity :</label>
                <input type="number" :value="glove.quantity" v-on:change="updateField('quantity', $event.target.value)" min="1" max="10"/> pair(s)
            </section>

            <section>
                <label>Color :</label>
                <button v-if="glove.color == null" class="focus" @click="this.openModal">Click here to choose your color</button>
                <div class="selected-color" v-if="glove.color != null">
                    <div>
                        <div v-if="glove.color != null" :class="'color ' + glove.color"></div>
                        <div class="color-detail">
                            <h4>{{ glove.colorLabelEN }}</h4>
                            <button v-if="glove.color != null" class="focus" @click="this.openModal">Change your color</button>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <button :disabled="!canOrder" class="focus" @click="addToCart">Click here to add those gloves to your cart</button>
            </section>

            <section>
                {{ cartDescription }}
                <button :disabled="!hasItems" @click="this.openCart" class="order-action">See your shopping cart <br />and finalize your order</button>
            </section>
        </div>
        <keep-alive>
            <color-chooser v-if="showColorModal" :lang="lang" :gender="glove.gender" :color="glove.color" :color-label="glove.colorLabelEN" @color_selected="onColorSelected"></color-chooser>
        </keep-alive>
    </div>
</template>

<script>
    import ColorChooser from './ColorChooser';

    export default {
      name: 'Product',
      data() {
        return {
          showColorModal: false,
          // gender: 'M',
          // size: '8',
          // quantity: 1,
          // color: null,
          // colorLabelFR: null,
          // colorLabelEN: null,
          cartDescription: '',
          glovePrice: 22000,
        };
      },
      props: ['lang'],
      components: { ColorChooser },
      methods: {
        openModal() {
          this.showColorModal = true;
          this.$emit('open_modal', { color: this.glove.color });
        },
        onColorSelected(values) {
          this.updateField('color', values.color);
          this.updateField('colorLabelFR', values.fr);
          this.updateField('colorLabelEN', values.en);
          this.showColorModal = false;
          this.$emit('close_modal');
        },
        onGenderChanged() {
          // resetting colors & updating model
          this.glove.color = null;
          this.glove.size = null;
        },
        addToCart() {
          const item = {
            name: `C${this.glove.color}-S${this.glove.size}-G${this.glove.gender}`,
            labelFR: `Gants ${this.glove.gender === 'M' ? 'Homme' : 'Femme'} / Taille ${this.glove.size} / Couleur ${this.glove.colorLabelFR}`,
            labelEN: `Glove ${this.glove.gender === 'M' ? 'Men' : 'Women'} / Size ${this.glove.size} / Color ${this.glove.colorLabelEN}`,
            quantity: this.glove.quantity,
            price: this.glovePrice,
            article: 'glove',
            type: this.glove.gender,
            size: this.glove.size,
            color: this.glove.color,
          };

          this.$store.commit('ADD_ITEM', item);
        },
        openCart() {
          const routes = this.$router.options.routes;
          const routeToCart = this.$router.options.getRouteByName(routes, `Checkout${this.lang.toUpperCase()}`);
          if (routeToCart) {
            this.$router.push(routeToCart);
          }
        },
        updateField(field, value) {
          this.$store.commit('updateSelectedGlove', { field, value });
        },
      },
      computed: {
        canOrder() {
          return this.glove.color != null;
        },
        hasItems() {
          return this.items.length > 0;
        },
        glove() {
          return this.$store.getters.glove;
        },
        items() {
          return this.$store.getters.items;
        },
      },
    };
</script>


<style lang="scss">
    .product {
        counter-reset: section-counter;
        margin:4rem auto auto auto;

        .inb {display:inline-block}



        ol li {
            list-style-image: url('../assets/section_icon.png');
            color:white;
        }

        section {
            margin-bottom:1.5rem;

            label {vertical-align: top;}
            input, select {
                vertical-align: middle;
                background-color: #ebe9e8;
            }
            input[type='number']{width:3rem; text-align: center}

            &:before {
                counter-increment: section-counter +1;
                content: counter(section-counter);
                background: url('../assets/section_icon.png') right no-repeat;
                padding:1px .8rem;

                margin-right:10px;
                vertical-align: top;
                font-size: .8rem;
                font-weight: bold;
                color:white;
            }
        }

        .selected-color {
            vertical-align: top;
            font-weight: bold;

            .color-detail {
                display: inline-block;

                h4 {
                    margin:0.5rem;
                    display: block;
                }
            }
        }

        button{
            &.order-action {
                padding:1rem;
                text-transform: uppercase;
                border: 0;
                cursor: pointer;
                color: white;
                background: url('../assets/cart_bg.png') no-repeat center;
                background-size: contain;
            }

            &:disabled {
                opacity:0.5;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Product.vue